export default __webpack_public_path__ + "static/media/live-timeless.440f46e6.png";